export default "__VITE_ASSET__iGPbjzAK__"